export const ROLES = {
  superadmin: 0,
  basic: 1,
  faculty: 2,
  career: 3,
  university: 4,
  teacher_previewer: 5,
  student_previewer: 6,
  admin_previewer: 7,
};

export const ROLES_TO_STRING = {
  0: 'superadmin',
  1: 'basic',
  2: 'faculty',
  3: 'career',
  4: 'university',
  5: 'teacher_previewer',
  6: 'student_previewer',
  7: 'admin_previewer',
};

export const COURSE_ROLES = {
  2: 'profesor del curso',
  3: 'estudiante activo',
  4: 'estudiante aprobado',
  5: 'estudiante reprobado',
  6: 'profesor en training',
  7: 'estudiante deshabilitado',
};

export const getSystemRoleName = (roleId) => {
  return ROLES_TO_STRING[roleId] || 'Unknown Role';
};

export const getCourseRoleName = (roleId) => {
  return COURSE_ROLES[roleId] || 'Unknown Role';
};
